var arrToObj = (arr) => {
  var obj = {};
  arr.forEach((a) => {
    obj[a[0]] = a[1];
  });
  return obj;
};
let types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  RADIO_BUTTON: "radio_button", 
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button",
};

let arr = [
  { id: "seq_id", label: "Unique Key", type: types.INPUT },
  {
    id: "change_time",
    label: "更新日",
    tab_size: 20,
    type: types.INPUT
  },
  {
    id: "user_id",
    label: "更新者(id)",
    tab_size: 10,
    type: types.INPUT
  },
  {
    id: "user_label",
    label: "更新者",
    tab_size: 15,
    type: types.INPUT
  },
  {
    id: "fk_tab",
    label: "種別",
    type: types.SELECT_BOX2,
    error_if_blank:true,
    options: [
      {value:1,label:"機器・組込情報"},
      {value:2,label:"証書情報"},
      {value:3,label:"tab_3"},
      {value:4,label:"tab_4"},
      {value:5,label:"tab_5"},
      {value:6,label:"tab_6"},
      {value:7,label:"tab_7"},
      {value:8,label:"証書情報"},
      {value:9,label:"ソフトウェア情報"},
      {value:51,label:"申請フロー"},
      {value:52,label:"申請フロー"},
    ],
    tab_size: 20,
  },
  {
    id: "fk_id",
    label: "fk_id",
    type: types.INPUT,
    tab_size: 15,
  },
  {
    id: "data_id",
    label: "証書管理番号",
    tab_size: 15,
    type: types.INPUT
  },
  {
    id: "mode",
    label: "操作",
    type: types.SELECT_BOX2,
    error_if_blank:true,
    options: [
      {value:1,label:"追加"},
      {value:2,label:"変更"},
      {value:3,label:"削除"},
      {value:4,label:"更新"},
    ],
    tab_size: 5,
  },
  {
    id: "description",
    label: "概要",
    tab_size: 50,
    type: types.INPUT
  },
  {
    id: "old_data",
    label: "古いデータ",
    tab_size: 20,
    type: types.INPUT
  },
  {
    id: "new_data",
    label: "新しいデータ",
    tab_size: 20,
    type: types.INPUT
  },
];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if(!RegExp("^[a-z][a-z0-9_]+$").test(e.id)){alert("Invalid field " + e.id);};
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
export const fields = ret;
export const filed_types = types;



// WEBPACK FOOTER //
// ./src/rules/fields_change_history.js